package com.applaunchkit.website.domain

import com.applaunchkit.website.util.Resource

enum class Feature(
    val title: String,
    val subtitle: String,
    val icon: String,
) {
    Frames(
        title = "Frames",
        subtitle = "Display your app shots in beautiful frames with multiple aspect ratios.",
        icon = Resource.Icon.FRAME
    ),

    Backgrounds(
        title = "Backgrounds",
        subtitle = "Create stunning visuals using futuristic gradients or solid colors.",
        icon = Resource.Icon.PALETTE
    ),

    Textures(
        title = "Textures",
        subtitle = "Add depth and personality with subtle texture overlays on the background.",
        icon = Resource.Icon.TEXTURE
    ),

    Mockups(
        title = "Mockups",
        subtitle = "Present your app in realistic Phone, Tablet, Laptop and Desktop mockups.",
        icon = Resource.Icon.MOBILE
    ),

    Customization(
        title = "Customizations",
        subtitle = "Fine-tune layouts, rotation, scale, colors and other styles to match your brand.",
        icon = Resource.Icon.FILTER
    ),

    Export(
        title = "Export",
        subtitle = "Export high-quality images ready for social media and stores.",
        icon = Resource.Icon.DOWNLOAD
    ),
}